/* eslint-disable import/first */
import React from 'react';
import { useNavigate, useLocation } from '@reach/router';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import { Button, FormControlLabel, Checkbox, Grid } from '@material-ui/core';
const { selectCountryValidations } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectStoreEntities } = Slices.storeSlice;
const { extraDetail } = Slices.appSlice;
// const { selectCountryValidations } = Slices.configSlice;
// const { selectCurrentCountry } = Slices.profileSlice;
// const { selectStoreEntities } = Slices.storeSlice;
// const { extraDetail } = Slices.appSlice;
import CookingInstructions from '../Cart/CookingInstructions';
import { FormattedMessage, useIntl } from 'react-intl';
import NoAddress from '../../components/AddressWidget/NoAddress';
// import homeIcon from './images/home.svg';
import { StoreIcon, Home, CarhopInst } from '../../components/Icons';
const { selectAddressRootState, selectDefaultAddress } = Slices.addressSlice;
import homeIcon from './images/homeIcon.svg';
import curbsideCar from './images/curbside.svg';
import dineInIcon from './images/dinein.svg';
import storeIcn from './images/shop.svg';

import css from './index.module.scss';
import classNames from 'classnames';

const ChangeAddressBox = ({
  isDesktop,
  foodInstr,
  handleFoodInstr,
  contactLessStatus,
  contactLessOnChange,
}) => {
  const extraInst = useSelector(extraDetail);
  const address = useSelector(selectAddressRootState);
  const defaultAddress = useSelector(selectDefaultAddress);
  const storeList = useSelector(selectStoreEntities);
  const location = useLocation();
  const [selectedStore, setSelectedStore] = React.useState({});
  const country = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const navigate = useNavigate();
  const intl = useIntl();

  const heading = {
    STORE: {
      main: intl.formatMessage({ id: 'checkout_pickup_store_detail' }),
      sub: <div className={css.addressTitle}></div>,
    },
    DELIVERY: {
      main: intl.formatMessage({ id: 'orderstatus_delivaryaddress' }),
      sub: <div className={css.addressTitle}></div>,
    },
    CARHOP: {
      main: intl.formatMessage({ id: 'checkout_carhopDetails' }),
      sub: (
        <div className={css.addressTitle}>
          {intl.formatMessage({ id: 'checkout_vehicleNo' })}
          <br />
          <span className={css.tableNumber}>{window.localStorage.getItem('dInst')}</span>
        </div>
      ),
    },
    DINEIN: {
      main: intl.formatMessage({ id: 'checkout_dineinDetails' }),
      sub: (
        <p className={classNames(css.addressTitle, css.dineInStyle)}>
          <FormattedMessage id="order_dineInDesc" defaultMessage="Serving Order To" /> <br />{' '}
          <span className={css.tableNo}>
            {' '}
            <FormattedMessage id="table_no" defaultMessage="Table No." />{' '}
            <span className={css.tableNumber}> {window.localStorage.getItem('dInst')}</span>
          </span>
        </p>
      ),
    },
    DRIVETHRU: {
      main: intl.formatMessage({ id: 'checkout_driveThruDetails' }),
      sub: <div className={css.addressTitle}></div>,
    },
  };

  const modeRoute = {
    DELIVERY: 'delivery',
    STORE: 'pickup',
    CARHOP: 'carhop',
    DINEIN: 'dinein',
    DRIVETHRU: 'drivethru',
  };
  const icons = {
    DELIVERY: { icon: <img src={homeIcon} /> },
    CARHOP: { icon: <img src={storeIcn} />, subIcon: <img src={curbsideCar} /> },
    STORE: { icon: <img src={storeIcn} /> },
    DINEIN: { icon: <img src={storeIcn} />, subIcon: <img src={dineInIcon} /> },
    DRIVETHRU: { icon: <img src={storeIcn} /> },
  };
  const handleChangeAddress = (e) => {
    e.preventDefault();
    if (Object.entries(defaultAddress).length) {
      if (isDesktop) {
        navigate(`${location.pathname}?modal=${defaultAddress.addressSubType.toLowerCase()}`);
      } else {
        navigate(`/${intl.locale}/${modeRoute[defaultAddress.addressSubType]}`, {
          state: { action: 'select' },
        });
      }
    }
  };
  const addressString = `address_${intl.locale}`;

  React.useEffect(() => {
    Object.values(storeList || {}).every((val) => {
      if (val.storeId === address?.default?.info?.data?.storeId) {
        setSelectedStore(val);
        return false;
      }
      return true;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className={css.section}>
        {Object.entries(defaultAddress).length ? (
          <div className={css.addressBox}>
            <div className={css.addressTitleMain}>
              <div>
                <h4>{heading[defaultAddress.addressSubType].main}</h4>
              </div>
              <div>
                <Button
                  variant="outlined"
                  color="secondary"
                  className={css.profileCardChange}
                  onClick={handleChangeAddress}
                >
                  <FormattedMessage id="checkout_change" defaultMessage="Change" />
                </Button>
              </div>
            </div>
            {defaultAddress.addressSubType !== 'DELIVERY' &&
              heading[defaultAddress.addressSubType].sub !== '' && (
                <>
                  <div className={css.addressList}>
                    <div
                      className={classNames(css.houseIcon, {
                        [css.imgIconStyle]:
                          defaultAddress.addressSubType !== 'DELIVERY' && isDesktop,
                      })}
                    >
                      {icons[defaultAddress.addressSubType].subIcon}
                    </div>
                    <div className={css.addressListItem}>
                      <div className={css.addressLable}>
                        {isDesktop && <h3>{heading[defaultAddress.addressSubType].sub}</h3>}
                      </div>
                      {!isDesktop && heading[defaultAddress.addressSubType].sub}
                      <div className={css.addressDescription}>{extraInst}</div>
                    </div>
                  </div>
                  <div className={css.spacing}></div>
                </>
              )}
            <div className={css.addressList}>
              <div className={css.houseIcon}>{icons[defaultAddress.addressSubType].icon}</div>
              <div className={css.addressListItem}>
                {/* <div className={css.addressLable}>
                {defaultAddress.addressSubType === 'DELIVERY' && (
                  <Button>{defaultAddress.tag} </Button>
                )}
                {isDesktop && <h3>{defaultAddress.bldgName}</h3>}
              </div> */}
                {/* {!isDesktop && ( */}
                <div
                  className={classNames(
                    css.addressTitle,
                    {
                      [css.block]: defaultAddress.addressSubType !== 'DELIVERY',
                    },
                    {
                      [css.mobileView]: defaultAddress.addressSubType === 'DELIVERY' && !isDesktop,
                    }
                  )}
                >
                  <Grid>
                    {defaultAddress.addressSubType === 'DELIVERY' && (
                      <Grid className={css.adDlvryLabel}>
                        {intl.formatMessage({ id: `${defaultAddress.tag.toLowerCase()}_tag` })}
                      </Grid>
                    )}
                    <Grid>
                      {defaultAddress.addressSubType !== 'DELIVERY' && (
                        <div className={css.storeAddressText}>
                          <FormattedMessage
                            id="trackorder_storeaddress"
                            defaultMessage="Store Address"
                          />
                        </div>
                      )}
                    </Grid>
                  </Grid>

                  <span className={css.addressStyle}>
                    {defaultAddress.addressSubType === 'DELIVERY' && defaultAddress.flatNum + ', '}
                  </span>

                  <span className={css.addressStyle}>{address?.default?.info?.data?.bldgName}</span>
                </div>
                {/* )} */}
                <div className={css.addressDescription}>
                  <span>
                    {address?.default?.info?.data?.addressType !== 'DELIVERY'
                      ? selectedStore?.[addressString]
                      : address?.default?.info?.data?.description}{' '}
                  </span>
                  {defaultAddress.addressSubType === 'DELIVERY' && defaultAddress.howToReach ? (
                    <span>
                      {' '}
                      <FormattedMessage id="nearestLandmark" defaultMessage="Nearest Landmark" />: :{' '}
                      {defaultAddress.howToReach}
                    </span>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>

            <div className={css.contactLess}>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={true}
                    disabled={true}
                    style={{
                      color: 'red',
                    }}
                    onChange={() => {}}
                    checked={true}
                  />
                }
                label={intl.formatMessage({ id: 'checkout_contactLessDelivery' })}
              />
            </div>
          </div>
        ) : (
          <NoAddress page={'checkout'} navigate={navigate} location={location} />
        )}
        {/* AS PER DESIGN COOKING INS SHOULD BE HIDE ON CHECKOUT */}
        {/* { !isDesktop && (
              <CookingInstructions
                title={countryValidations?.specialCookingTitle}
                placeholder={countryValidations?.specialCookingInstrPlaceholder}
                note={countryValidations?.specialCookingInstrNote}
                foodInstr={foodInstr}
                handleFoodInstr={handleFoodInstr}
              />
            )} */}
      </div>
      {/* {isDesktop && (
            <CookingInstructions
              title={countryValidations?.specialCookingTitle}
              placeholder={countryValidations?.specialCookingInstrPlaceholder}
              note={countryValidations?.specialCookingInstrNote}
              classname={css.checkoutCooking}
            />
          )} */}
    </>
  );
};

export default ChangeAddressBox;
